import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    localStorage.removeItem('adminToken');

    try {
      const success = await login(email, password);
      if (success) {
        setTimeout(() => navigate('/admin'), 100);
      } else {
        setError('Invalid email or password');
      }
    } catch {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-offblack flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-12">
          <span className="font-display font-bold text-3xl tracking-[0.04em] text-offwhite">
            ARMÉ.
          </span>
          <p className="text-warmgray-500 text-xs tracking-[0.15em] uppercase mt-2">Admin Portal</p>
        </div>

        {/* Error */}
        {error && (
          <div className="mb-6 p-3 border border-red-500/30 bg-red-500/10 text-red-300 text-sm text-center">
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="login-email" className="block text-xs tracking-[0.1em] uppercase text-warmgray-400 mb-2 font-sans">
              Email
            </label>
            <input
              id="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 bg-white/5 border border-white/10 text-offwhite text-sm placeholder:text-warmgray-600 focus:outline-none focus:border-white/30 transition-colors"
              placeholder="admin@arme-store.com"
              disabled={loading}
            />
          </div>

          <div>
            <label htmlFor="login-password" className="block text-xs tracking-[0.1em] uppercase text-warmgray-400 mb-2 font-sans">
              Password
            </label>
            <input
              id="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 bg-white/5 border border-white/10 text-offwhite text-sm placeholder:text-warmgray-600 focus:outline-none focus:border-white/30 transition-colors"
              placeholder="••••••••"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3.5 bg-offwhite text-offblack text-xs font-medium tracking-[0.12em] uppercase hover:bg-warmgray-200 transition-colors disabled:opacity-50"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <span className="w-4 h-4 border-2 border-warmgray-400 border-t-offblack rounded-full animate-spin" />
                Signing in...
              </span>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
